import { education } from '@/data/education';
import { formatDateRange } from '@/utils/cn';
import { Container, SectionHeading } from '@/components/common/SectionHeading';
import styles from './Education.module.css';

export function Education() {
  return (
    <section id="education" className="section" aria-labelledby="education-heading">
      <Container>
        <SectionHeading
          id="education-heading"
          eyebrow="Education"
          title="Academic background"
          description="Formal study in software engineering and related foundations."
        />
        <div className={styles.grid}>
          {education.map((item) => (
            <article key={item.id} className={styles.card}>
              <p className={styles.dates}>{formatDateRange(item.startYear, item.endYear)}</p>
              <h3 className={styles.institution}>{item.institution}</h3>
              <p className={styles.degree}>{item.degree}</p>
              <ul className={styles.details}>
                {item.details.map((detail) => (
                  <li key={detail}>{detail}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </Container>
    </section>
  );
}
